import { getToken } from './authUtils';
import ServicioURLManager from './servicioUrlManager';

/**
 * ## Interfaz: Categoria
 * Representa una categoría con nombre, descripción, cantidad de productos e imagen.
 */
export interface Categoria {
  id: string;
  name: string;
  description: string;
  productCount: number;
  image: string;
}

/**
 * ## Función: generarImagen
 * Genera una URL de imagen en base al nombre de la categoría.
 *
 * @param {string} nombre - Nombre de la categoría.
 * @returns {string} URL de la imagen generada.
 */
const generarImagen = (nombre: string): string => {
  const texto = encodeURIComponent(nombre);
  return `https://api.a0.dev/assets/image?text=${texto}&aspect=1:1`;
};

/**
 * ## Función: fetchCategoriasDesdeAPI
 * Realiza una solicitud POST al endpoint /getCategoriasSSE para obtener categorías del sistema.
 *
 * ## Versión: 1.0.3
 *
 * @returns {Promise<Categoria[]>} Lista de categorías transformadas.
 * @throws {Error} Si ocurre un problema durante la solicitud o transformación.
 */
export const fetchCategoriasDesdeAPI = async (): Promise<Categoria[]> => {
  try {
    const serverUrl = await new Promise<string>((resolve, reject) => {
      ServicioURLManager.getUrlServicios((result, error) => {
        if (error || !result?.[0]?.Url) {
          reject("No se pudo obtener la URL del servidor.");
        } else {
          resolve(result[0].Url);
        }
      });
    });

    const response = await fetch(`${serverUrl}/getCategoriasSSE`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: getToken(),
        Texto: "",
        MenuResto: "S"
      })
    });

    const text = await response.text();

    // Extraer la última línea que comience con 'data: '
    const dataLines = text
      .split('\n')
      .filter(line => line.trim().startsWith('data: '))
      .map(line => line.replace(/^data: /, ''));

    const lastData = dataLines.pop();

    if (!lastData) throw new Error("No se encontró contenido válido en la respuesta SSE.");

    const json = JSON.parse(lastData);
 

    if (!Array.isArray(json?.data)) return [];

    return json.data.map((cat: any) => ({
      id: String(cat.Id ?? cat.IdRamo ?? Math.random()),
      name: cat.name || 'Sin nombre',
      description: (cat.Detalle ?? '').trim() || "Sin descripción",
      productCount: cat.total_items ?? 0,
      image: generarImagen(cat.name || 'categoria')
    }));
  } catch (error) {
    console.error("Error al obtener categorías:", error);
    return [];
  }
};